import axios from 'axios';

export default function setDefaultHeader(header, value) {
    if (value && header) {
        axios.defaults.headers.common[header] = `${value}`;
    } else if (header) {
        delete axios.defaults.headers.common[header];
    }
}